import { render, staticRenderFns } from "./delete_character.vue?vue&type=template&id=2232346b"
import script from "./delete_character.vue?vue&type=script&lang=ts"
export * from "./delete_character.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports